export default __webpack_public_path__ + "static/analysis-i-f4fc089bc3ff6157d21b6dbb10ca146c.svg";